<template>
  <div class="pie-graph">
    <div class="card">
      <h4 v-if="title">{{ title }}</h4>

      <div class="graph-container">
        <pie-chart
          :key="$route.name"
          :chart-data="chartData"
          :options="chartOptions"
        />
      </div>

      <div class="legend" v-if="legend.length > 1">
        <span class="legend-set" v-for="(set, i) in legend" :key="i">
          <span class="legend-dot" :style="{ 'background-color': set.color }" />
          <span>{{ set.label }}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import PieChart from './PieChart';

export default {
  components: {
    PieChart,
  },

  props: {
    labels: Array,
    datasets: Array,
    title: String,
  },

  computed: {
    chartOptions() {
      return {
        responsive: true,
        legend: {
          display: false,
        },
        tooltips: {
          titleFontFamily: 'Lato',
          titleFontSize: 14,
          titleMarginBottom: 10,
          bodyFontFamily: 'Poppins',
          bodyFontSize: 18,
          xPadding: 20,
          yPadding: 20,
          cornerRadius: 7,
          callbacks: {
            title(tooltipItem, data) {
              return data.labels[tooltipItem[0].index];
            },
            label: (tooltipItem, data) => ` — ${this.$filters.currency(data.datasets[0].value[tooltipItem.index], { full: true })} (${this.$filters.percentage(data.datasets[0].data[tooltipItem.index])}%)`,
          },
        },
      };
    },

    chartData() {
      return {
        labels: this.labels,
        datasets: [{
          label: 'Pie Graph',
          backgroundColor: this.datasets.map(({ borderColor }) => borderColor),
          data: this.datasets.map(({ data }) => data),
          value: this.datasets.map(({ value }) => value),
        }],
      };
    },

    legend() {
      if (!this.datasets || this.datasets.length < 2) {
        return [];
      }

      return this.datasets.map(({ label, borderColor }) => ({
        label,
        color: borderColor,
      }));
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.graph-container {
  max-width: 360px;
  margin: 0 auto;
  padding: $gp;

  @media($small-down) {
    max-width: 240px;
  }
}

.card {
  height: 100%;
}

.legend {
  padding-top: $gp;
  text-align: center;
}

.legend-set {
  display: inline-flex;
  align-items: center;

  &:not(:last-child) {
    padding-right: $gp;
  }
}

.legend-dot {
  @include circle(10px);

  margin-right: $gp * .5;
}
</style>
